import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=d6a7912a&scoped=true"
import script from "./Messaging.vue?vue&type=script&lang=js"
export * from "./Messaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a7912a",
  null
  
)

export default component.exports